import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-text-header',
    templateUrl: './text-header.component.html',
    styleUrls: ['./text-header.component.scss'],
    standalone: false
})
export class TextHeaderComponent implements AfterViewInit {
    @Input() text: string;
    @ViewChild('textField', { static: false }) textFieldEl!: ElementRef<HTMLElement>;
    truncated: boolean = false;
    private resizeObserver!: ResizeObserver;

    ngOnDestroy(): void {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
    }

    ngAfterViewInit(): void {
        const el = this.textFieldEl.nativeElement;
        this.resizeObserver = new ResizeObserver(() => {
            this.truncated = el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth;
        });
        this.resizeObserver.observe(el);
        this.truncated = el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth;
    }

}
